import { Button } from '@mui/material';
import { useFormik } from 'formik';
import { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getBlogByIdFn, getBlogSubCategoryFn, patchBlogFn, postBlogFn } from 'Services/Blog';
import CustomInput from 'Shared/CustomInput';
import ImageInput from 'Shared/ImageInput';
import RichTextEditor from 'Shared/RichTextEditory';
import SelectInput from 'Shared/SelectInput';

const AddUpdateBlog = () => {
    const [subOptions, setSubOptions] = useState([]);
    const navigate = useNavigate();
    const { id, status } = useParams();

    useQuery({
        queryKey: ['get-sub-category'],
        queryFn: getBlogSubCategoryFn,
        onSuccess: (response) => {
            const category = response?.data?.data;
            const options = category?.map((item) => ({ label: item?.name, value: item?.id }));
            setSubOptions(options);
        }
    });

    const { data: response } = useQuery({
        queryKey: ['get-sub-category-by-id', id, status],
        queryFn: () => getBlogByIdFn(id),
        enabled: !!id && status === "update"
    });
    const data = response?.data?.data;

    const { mutate: post } = useMutation(postBlogFn, {
        onSuccess: (response) => {
            toast.success(response?.data?.message);
            navigate('/blog/');
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message);
        }
    });

    const { mutate: patch } = useMutation(patchBlogFn, {
        onSuccess: (response) => {
            toast.success(response?.data?.message);
            navigate('/blog/');
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message);
        }
    });

    const initialValues = {
        sub_category: data?.sub_category || "",
        image: "",
        title: data?.title || "",
        content: data?.content || ""
    };

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: (values) => {
            if (!values.title) return toast.error("Title is required.");
            if (!values.sub_category) return toast.error("Sub Category is required.");
            if (!values.content) return toast.error("Content is required.");

            const formData = new FormData();
            formData.append('title', values.title);
            formData.append('content', values.content);
            formData.append('sub_category', values.sub_category);

            if (status === 'add') {
                if (!values.image) return toast.error("Image is required.");
                formData.append('image', values.image);
                post(formData);
            } else {
                if (values.image) formData.append('image', values.image);
                formData.append("blog_id", id);
                patch(formData);
            }
        }
    });

    return (
        <div className="p-4">
            <form
                className="bg-white shadow-md rounded-lg mx-auto p-6 flex flex-col gap-6"
                onSubmit={formik.handleSubmit}
            >
                <p className="text-xl text-black font-bold text-center">
                    {status === "update" ? "Update" : "Add"} Blog
                </p>
                <CustomInput formik={formik} label="Title" name="title" />
                <SelectInput formik={formik} label="Sub Category" name="sub_category" options={subOptions} />
                <ImageInput formik={formik} label="Image" name="image" />
                <RichTextEditor formik={formik} label={"Content"} name={"content"} />
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                >
                    {status === "update" ? "Update" : "Add"}
                </Button>
            </form>
        </div>
    );
};

export default AddUpdateBlog;
